import { formatNewsDate } from "./homePage";
import { API_ENDPOINTS } from "./config";

const BLOGS_API = API_ENDPOINTS.blogs;

let blogsPageRequest = null;
const blogDetailRequests = {};

export const mapBlogs = (items = []) =>
  [...items]
    .sort((a, b) => b.id - a.id)
    .map((item) => ({
      id: item.id,
      title: item.title || "",
      tag: item.tag || "",
      description: item.description || "",
      highlight: item.highlight || "",
      image: item.image,
      date: formatNewsDate(item.created_at),
      to: `/blog/${item.id}`,
    }));

export const mapBlogDetail = (item) => {
  if (!item) return null;

  return {
    id: item.id,
    title: item.title || "",
    tag: item.tag || "",
    description: item.description || "",
    highlight: item.highlight || "",
    image: item.image,
    date: formatNewsDate(item.created_at),
  };
};

export const fetchBlogsPage = async () => {
  if (blogsPageRequest) return blogsPageRequest;

  blogsPageRequest = fetch(BLOGS_API)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch blogs page data (${response.status})`);
      }

      const data = await response.json();

      return {
        blogs: mapBlogs(data.data),
        contact: data.contacts?.[0] || null,
      };
    })
    .catch((error) => {
      blogsPageRequest = null;
      throw error;
    });

  return blogsPageRequest;
};

export const fetchBlogDetail = async (id) => {
  if (blogDetailRequests[id]) return blogDetailRequests[id];

  blogDetailRequests[id] = fetch(`${BLOGS_API}/${id}`)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch blog detail (${response.status})`);
      }

      const payload = await response.json();

      return {
        blog: mapBlogDetail(payload.data),
        contact: payload.contacts?.[0] || null,
      };
    })
    .catch((error) => {
      delete blogDetailRequests[id];
      throw error;
    });

  return blogDetailRequests[id];
};
